import { trackAction } from 'helpers/trackingOM';

/* set click event for the overlay close button */
$('button.close').on('click', function (e) {
    e.preventDefault();
    $('.overlay.active').fadeOut();
    $('.pin-container-wrapper.active').fadeOut();

    $('.overlay.active').removeClass('active');
    $('.pin-container-wrapper.active').removeClass('active');
});

CBS.Promises.Tracking.onLoad(function () {
    if (
        typeof $('.pin-container-wrapper') !== 'undefined' &&
        $('.pin-container-wrapper').length > 0
    ) {
        /* set tracking -  overlay display */
        om.trackState({
            pinOverlayPromptView: '1',
            pageName: 'kids overlay'
        });
    }
});

/* set tracking -  button : take me there */
$('div#take-me-there').on('click', function (e) {
    e.preventDefault();
    trackAction('trackPinOverlayTakeMeThere', {
        pinOverlayTakeMeThere: '1'
    });
    setTimeout(function () {
        window.location.href = 'https://www.paramountplus.com/account/?target=set-pin';
    }, 1000);
});

/* set tracking -  button : no, thanks */
$('div#no-thanks').on('click', function (e) {
    e.preventDefault();

    $('.overlay.active').fadeOut();
    $('.pin-container-wrapper.active').fadeOut();

    $('.overlay.active').removeClass('active');
    $('.pin-container-wrapper.active').removeClass('active');
    trackAction('trackPinOverlayNoThanks', {
        pinOverlayNoThanks: '1'
    });
});
